module.exports = __webpack_public_path__ + "static/img/new9m.9b8874b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/new9m.jpg
// module id = qbQi
// module chunks = 1